import React from "react";
import { Modal } from "react-bootstrap";
import useLangTranslation from "../../../customHooks/languageProvider";
import DeleteDevicePic from "../../../../assets/images/deletedSuccessfully.png";
// import { useDispatch } from "react-redux";

const DeleteTasks = ({
  showModal,
  setDeleteTaskModal,
  handleDeleteTask
}) => {
  const { getLangTranslation } = useLangTranslation();
  // const [loader, setLoader] = useState(false);
  const closeDeletedModal = () => {
    setDeleteTaskModal(false);
  };

  return (
    <>
      <Modal
        show={showModal}
        size="sm"
        className="custom-modal blur-bg"
        centered
      >
        <Modal.Header>
          <div className="border-0 pb-0 d-flex justify-content-between w-100">
            {/* <h6 className="modal-title text-blue-900">
              {getLangTranslation("Account")?.replace(" the ", " ")}
            </h6> */}
            <button
              type="button"
              className="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
              onClick={closeDeletedModal}
            ></button>
          </div>
        </Modal.Header>
        <Modal.Body className="py-1 px-4">
          <div className="modal-body">
            <img
              className="d-block mx-auto mt-6"
              src={DeleteDevicePic}
              alt=""
            />
            <h5 className="text-center mb-3">
              {getLangTranslation("ARE_YOU_SURE_WANT_TO_DEL_TASK_TXT", "Are you sure you want to delete this Task?")}
            </h5>
            <div className="grid gap-3">
              <button
                className="btn btn-outline-primary g-col-6"
                type="button"
                data-bs-dismiss="modal"
                aria-label="Close"
                onClick={() => setDeleteTaskModal(false)}
              // disabled={loader}
              >
                <span className="btn-upper-case">
                  {getLangTranslation("CANCEL", "CANCEL")}
                </span>
              </button>
              <button
                className="btn btn-primary g-col-6"
                type="button"
                data-bs-dismiss="modal"
                aria-label="Close"
                onClick={() => handleDeleteTask()}
              // disabled={loader}
              >
                <span className="btn-upper-case">{getLangTranslation("DELETE", "DELETE")}</span>
              </button>
            </div>
          </div>
        </Modal.Body>
      </Modal>

      {/* <DeletedSuccessfully
        showDeletedModal={showDeletedModal}
        closeDeletedModal={closeDeletedModal}
      /> */}
    </>
  );
};

export default DeleteTasks;
